// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","overlay":"_1b2Z8BQg4IPvLIqW"};